module.exports = __webpack_public_path__ + "static/media/i3_logomark.bd4856ac.svg";